import { Constants } from './../../shared/Helpers/constants';
import { Component, OnInit, DoCheck } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UserService, AuthenticationService } from '../../_services';
import { SharedService } from '../../shared/shared.service';
import { environment } from '@env/environment';
import { Alert, AlertTypeEnum } from 'src/app/shared/Helpers/Alert';

@Component({
  selector: 'email-confirmation',
  templateUrl: './email-confirmation.html'
})
export class EmailConfirmationComponent implements OnInit, DoCheck {
  public isUserAuthenticated: boolean = false;
  public showLoading: boolean = true;
  public emailConfirmed: boolean = true;
  public logoPath: any;
  public returnUrl: string;
  private token: string;
  private tenant: string;

  constructor(
    private _activedRoute: ActivatedRoute,
    private _userService: UserService,
    private sharedService: SharedService,
    private _authenticationService: AuthenticationService
  ) {
    this.tenant = this._activedRoute.snapshot.paramMap.get('tenant');
    this.token =  this._activedRoute.snapshot.paramMap.get('token');
  }

  ngOnInit(): void {
    const curretnUserToken: string = localStorage.getItem(Constants.localStorage_currentUser);

    if (curretnUserToken) {
      this.isUserAuthenticated = true;
    }
    else {
      this.isUserAuthenticated = false;
    }

    this._userService.contactConfiramtion(this.token, this.tenant).subscribe({
      next: (res) => {
        this.showLoading = false;
        this.emailConfirmed = true;
      },
      error: (err) => {
        this.showLoading = false;
        this.emailConfirmed = false;
        const errorMessage: string = `Sorry, this link has expired. Please contact your organisation's Able+ administrator, to request a new confirmation link.`;
        Alert.basicNotification(AlertTypeEnum.Error, "Email confirm error", errorMessage);
      }
    });
  }

  ngDoCheck() {
    if (this.sharedService.loadedOrganisationByUrl.value) {
      if (this.sharedService.loginCustomisation.value != undefined && this.sharedService.loginCustomisation.value != null) {
        if (this.sharedService.LogoImage.value != null) {
          this.logoPath = null;
          this.logoPath = this.sharedService.LogoImage.value;
        }
        else {
          this.logoPath = Constants.logoPath;
        }
      }
      else {
        this.logoPath = Constants.logoPath;
      }
    }
    else {
      this.logoPath = Constants.logoPath;
    }
  }

  public redirectToAble() {
    this.returnUrl = environment.default_return_url;
    this._authenticationService.redirect(this.returnUrl)
  }
}
